import React from 'react'

export default class URLList extends React.Component {
     constructor(props) {
        super(props)
        this.state = {
            value: this.props.defaultValue || [],
            isAdd: false,
            title: '',
            href: '',
        }
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.defaultValue !== this.state.value) {
            this.setState({
                value: nextProps.defaultValue || []
            })
        }
        this.setState({
            isAdd: false,
            title: '',
            href: ''
        })
    }
    render() {
        return (
            <p>
                <strong>URLs</strong> <span className="add-url" onClick={()=>{this.setState({isAdd: !this.state.isAdd})}}>{this.state.isAdd?'(Cancel)':'(+ Add)'}</span><br/>
                <span className="urllist">
                {
                    (!this.props.disabled && this.state.isAdd)
                        ? (
                            <span className="input-url">
                                <input type="text" spellCheck="false" placeholder="Title" value={this.state.title} onChange={e=>{this.setState({title: e.target.value})}}/>
                                <input type="text" spellCheck="false" placeholder="URL" value={this.state.href} onChange={e=>{this.setState({href: e.target.value})}}/>
                                <span onClick={()=>{
                                    if (this.state.href==='') {
                                        return
                                    }

                                    // allow to set url with empty title, but set title to href
                                    let newTitle = this.state.title
                                    if (newTitle==='') {
                                        newTitle = this.state.href
                                    }

                                    let val = [...this.state.value, {
                                        title: newTitle,
                                        href: this.state.href
                                    }]

                                    this.setState({
                                        title: '',
                                        href: '',
                                        value: val,
                                    }, ()=>{
                                        this.props.onChange(this.state.value)
                                    })
                                }}>Add</span>
                            </span>
                        )
                        : null
                }
                {
                    this.state.value.map((url,id)=>(
                        <span className="listitem" key={url+id}>
                            <a target="_blank" title={url.title} href={url.href}>{url.title}</a>
                            <svg width="12" height="12" viewBox="0 0 20 20" title="Remove link" onClick={()=>{
                                let val = []
                                this.state.value.forEach((u,_id)=>{
                                    if (_id!==id) {
                                        val.push(u)
                                    }
                                })
                                this.setState({
                                    value: val
                                }, ()=>{
                                    this.props.onChange(this.state.value)
                                })
                            }}>
                                <path d="M10.707 10.5l5.646-5.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-5.646 5.646-5.646-5.646c-0.195-0.195-0.512-0.195-0.707 0s-0.195 0.512 0 0.707l5.646 5.646-5.646 5.646c-0.195 0.195-0.195 0.512 0 0.707 0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146l5.646-5.646 5.646 5.646c0.098 0.098 0.226 0.146 0.354 0.146s0.256-0.049 0.354-0.146c0.195-0.195 0.195-0.512 0-0.707l-5.646-5.646z"></path>
                            </svg>
                        </span>
                    ))
                }
                {
                    (this.state.value.length===0 && !this.state.isAdd)
                        ? <span style={{color: '#888'}}><i>None added</i></span>
                        : null
                }
                </span>
            </p>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/URLList.js